/**
 * Help & support dropdown panel shown from the header.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomerSupportCard from '@/shared/components/CustomerSupportCard.jsx';

const HelpSupportMenu = ({ onStartTour, style }) => {
  const { t } = useTranslation();

  return (
    <div className="help-support-menu dropdown-menu" style={style} role="menu">
      <div className="help-support-menu__header">
        <h3 className="help-support-menu__title">
          {t('helpAndSupport', { ns: 'common', defaultValue: 'Help & Support' })}
        </h3>
        <p className="help-support-menu__subtitle">
          {t('helpAndSupportSubtitle', {
            ns: 'common',
            defaultValue: 'Take a guided tour or reach our official support team.',
          })}
        </p>
      </div>

      <button type="button" className="help-support-menu__tour" onClick={onStartTour} role="menuitem">
        <span className="material-symbols-outlined" aria-hidden="true">
          explore
        </span>
        {t('startPageTour', { ns: 'common', defaultValue: 'Start page tour' })}
      </button>

      <div className="help-support-menu__support">
        <CustomerSupportCard />
      </div>
    </div>
  );
};

export default HelpSupportMenu;
